import Box from '@/Atoms/Box';
import CCButton from '@/Atoms/CCButton';
import CCText from '@/Atoms/CCText';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import CCColors from '@/Utils/CCColors';
import {FontSizes, vs} from '@/Utils/Dimensions';
import {MaterialCommunityIcons} from '@expo/vector-icons';
import {LinearGradient} from 'expo-linear-gradient';
import {StyleSheet} from 'react-native';

interface BannerProps {
  backgroundColor: string;
  iconName: string;
  iconColor?: string;
  titleText: string;
  subtitleText?: string;
  ctaText?: string;
  onClose: () => void;
  handlePress: () => void;
  closeIcon?: boolean;
  borderColor?: string;
  highlight?: number;
  textColor?: '';
  isMobileOrTab?: boolean;
}

const MeetingsBanner: React.FC<BannerProps> = ({
  backgroundColor,
  iconName,
  iconColor,
  titleText = 'Get 20% off—upgrade your plan today',
  subtitleText = 'Get 20% off—upgrade your plan today',
  ctaText = 'View Plans',
  onClose,
  handlePress,
  closeIcon,
  borderColor,
  highlight,
  textColor,
  isMobileOrTab,
}) => {
  return (
    <Box
      flexDirection={isMobileOrTab ? 'column' : 'row'}
      alignItems="center"
      justifyContent="space-between"
      style={styles.container}>
      <Box
        flexDirection={'row'}
        justifyContent="flex-start"
        gap={0}
        style={[
          {
            padding: isMobileOrTab ? vs(10) : vs(5),
          },
        ]}
        alignItems={isMobileOrTab ? 'flex-start' : 'center'}>
        {isMobileOrTab ? (
          <Box
            alignItems="center"
            justifyContent="center"
            style={[
              styles.iconWrapper,
              {
                backgroundColor: isMobileOrTab ? 'none' : backgroundColor,
                borderColor: borderColor,
                width: isMobileOrTab ? 18 : 25,
                height: isMobileOrTab ? 18 : 25,
              },
            ]}>
            <MaterialCommunityIcons
              name={iconName}
              size={13}
              color={iconColor}
            />
          </Box>
        ) : (
          <LinearGradient
            colors={['#E17846', '#e0850f']}
            start={{x: 1, y: 0}}
            end={{x: 0, y: 0}}
            style={[
              styles.iconWrapper,
              {
                width: 35,
                height: 35,
                borderRadius: 17,
                marginLeft: 20,
              },
            ]}>
            <MaterialCommunityIcons
              name={iconName}
              size={17}
              color={iconColor}
              style={{}}
            />
          </LinearGradient>
        )}
        <Box
          flexDirection={isMobileOrTab ? 'row' : 'column'}
          style={{
            paddingLeft: isMobileOrTab ? 5 : 10,
          }}>
          <CCText
            fontWeight={600}
            color={textColor}
            fontSize={FontSizes[14]}
            style={[
              styles.titleText,
              {
                paddingHorizontal: isMobileOrTab ? 20 : 5,
              },
            ]}>
            {titleText}
          </CCText>
          {subtitleText && (
            <CCText
              color={textColor}
              fontWeight={400}
              fontSize={FontSizes[12]}
              style={styles.subtitleText}>
              {subtitleText}
            </CCText>
          )}
        </Box>
      </Box>
      {!isMobileOrTab && (
        <Box
          flexDirection="row"
          alignItems="center"
          gap={8}
          style={styles.rtbox}>
          <CCButton
            contentContainerStyle={styles.ctaButtonContent}
            onPress={handlePress}
            style={[
              styles.ctaButton,
              {
                backgroundColor: highlight
                  ? CCColors.Primary.Default
                  : CCColors.CCTableBg,
              },
            ]}>
            <CCText fontWeight={500} fontSize={FontSizes[12]}>
              {ctaText}
            </CCText>
          </CCButton>
          {closeIcon && (
            <Box
              onPress={onClose}
              alignItems="center"
              justifyContent="center"
              style={styles.closeButton}>
              <MaterialCommunityIcons name="close" size={14} />
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    paddingRight: 5,
    borderRadius: 8,
    overflow: 'hidden',
  },
  iconWrapper: {
    width: 25,
    height: 25,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
  },
  titleText: {
    paddingHorizontal: 20,
  },
  subtitleText: {
    paddingHorizontal: 5,
  },
  ctaButtonContent: {
    paddingHorizontal: 12,
    paddingVertical: 5,
  },
  ctaButton: {
    marginHorizontal: 8,
  },
  closeButton: {
    width: 25,
    height: 25,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: CCColors.CCTableBg,
  },
  rtbox: {
    marginRight: 5,
  },
  text: {
    maxWidth: '90%',
  },
});

export default MeetingsBanner;
